var _excluded = ["homepassModalOpen", "closeHomepassModal", "onBookInspectionClick", "submitHomepassBooking"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import 'intersection-observer';
import React, { useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Element } from 'react-scroll';
import { Modal } from '@domain-group/fe-blueprint-ui/modal';
import { variables } from '@domain-group/fe-brary';
import HomepassBooking from '@domain-group/fe-co-homepass-booking';
import { ListingType } from '@domain-group/fe-allhomes-library';
import { EventBoundary, withEventBoundary, useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import { ListingEnquiryFormGraphQL, MobileEnquiryCTAGraphQL } from '@domain-group/fe-co-allhomes-enquiry-form';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import { AllhomesKeyDetailsGraphQL } from '@domain-group/fe-co-allhomes-key-details';
import { AllhomesListingMapGraphQL } from '@domain-group/fe-co-allhomes-listing-map';
import { AllhomesListingMoreListingsGraphQL } from '@domain-group/fe-co-allhomes-listing-more-listings';
import AllhomesListingPhotoCarousel from '@domain-group/fe-co-allhomes-listing-photo-carousel';
import { AllhomesListingSoiGraphQL } from '@domain-group/fe-co-allhomes-listing-soi';
import { AllhomesListingSuburbStatsGraphQL } from '@domain-group/fe-co-allhomes-listing-suburb-stats';
import { AllhomesListingSummaryGraphQL } from '@domain-group/fe-co-allhomes-listing-summary';
import NearbySales from '@domain-group/fe-co-allhomes-nearby-sales';
import { PropertyHistoryGraphQL } from '@domain-group/fe-co-allhomes-property-history';
import StickyMobile from '@domain-group/fe-co-allhomes-sticky-footer';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import FlagAsInappropriateLink from '../components/flag-as-inappropriate-link';
import { ListingViewsGraphQL } from '../components/listing-views';
import { NewDevelopmentChildDetailsGraphQL } from '../components/new-development-child-details';
import OnMarketSidebox from '../components/on-market-sidebox';
import StickySidebox from '../components/sticky-sidebox';
import DocumentsGraphQL from '../components/documents/documents-graphql';
import DevelopmentHeader from '../components/development-header/development-header';
import { InspectionsAuctionsGraphQL } from '../components/inspections-auctions';
import ListingPhotoPreview from '../components/allhomes-listing-hero-photo-preview';
import { Inner, InnerLeft, InnerRight, Section, HeroImages, Clear, Bottom } from '../components/structure';
import NextEventGraphQL from '../components/next-event/next-event-graphql';
import { FeaturedArticle } from '../components/editorial';
import AllhomesListingWhatsNearbyGraphQL from '../components/what-is-nearby/allhomes-listing-whats-nearby-graphql';
import { NbnCardGraphQL } from '../components/nbn-card';
import { onMarketPropertyWrapper } from '../wrappers';
import { scrollToEnquiryForm, scrollTo } from '../utils/scrolling';
import useBackToSearch from '../utils/back-to-search';
import useHomepass from '../utils/homepass';
import ListingDetailsCommonProps, { ListingDetailsDefaultValues } from '../props/common-props';
import useSendPageView from '../analytics/use-send-page-view';
import MobileAdSpot from '../components/mobile-ad-spot';
import { PepperMoney } from '../components/peppermoney';
import * as sharedStyles from './on-market.style';
import * as styles from './on-market-sales.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseOnMarketSalesListingDetails = props => {
  var _property$agents$, _property$agents, _property$development, _property$development2, _property$development3, _property$development4, _property$development5, _property$development6, _property$listing, _property$listing$med, _property$listing2, _props$listingVisibil, _property$address, _props$listingVisibil2, _property$address2, _property$address3, _property$address4, _property$address4$di, _property$agents$2;
  useSendPageView();
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var sidebarBottomRef = useRef();
  var enquiryFormStart = useRef();
  var _useHomepass = useHomepass(props),
    homepassModalOpen = _useHomepass.homepassModalOpen,
    closeHomepassModal = _useHomepass.closeHomepassModal,
    onBookHomepassInspectionClick = _useHomepass.onBookInspectionClick,
    submitHomepassBooking = _useHomepass.submitHomepassBooking,
    homepassProps = _objectWithoutProperties(_useHomepass, _excluded);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var property = props.property;
  var _props$media = props.media,
    mobile = _props$media.mobile,
    tablet = _props$media.tablet,
    desktop = _props$media.desktop;
  var listingType = ListingType[props.property.listing.type];
  var isSold = property.listing.status === 'SOLD';
  var isForSale = property.listing.status === 'FOR_SALE';
  var isCommercial = listingType.isCommercial;
  var showNearbySales = !isSold && !isCommercial;
  var isChildDev = listingType.name === ListingType.SALES_RESIDENTIAL.name && props.property.development;
  var backToSearch = useBackToSearch(props.referrer);
  var handleEmailClick = (agency, agent) => {
    scrollToEnquiryForm({
      agency,
      agent
    });
  };
  var handleChildDevelopmentLinkClick = () => {
    sendEvent('child-new-dev-website-link-click');
    if (props.onChildDevelopmentLinkClick) {
      props.onChildDevelopmentLinkClick();
    }
  };
  var scrollToAuction = () => {
    scrollTo('online-auction');
  };
  var hasPrivateLister = (_property$agents$ = property.agents[0]) === null || _property$agents$ === void 0 ? void 0 : _property$agents$.isPrivateLister;
  var hasAgents = ((_property$agents = property.agents) === null || _property$agents === void 0 ? void 0 : _property$agents.length) > 0;
  var previewProps = {
    galleryUrl: props.galleryUrl,
    virtualTourUrl: props.virtualTourUrl,
    videoUrl: props.videoUrl,
    floorPlanUrl: props.floorPlanUrl,
    onClickGallery: props.onClickGallery,
    onClickVirtualTour: props.onClickVirtualTour,
    onClickVideo: props.onClickVideo,
    onClickFloorPlan: props.onClickFloorPlan,
    onImageChanged: props.onImageChanged,
    onImageDisplayed: props.onImageDisplayed,
    onNavigationArrowClicked: props.onNavigationArrowClicked,
    onScrolledLeft: props.onScrolledLeft,
    onScrolledRight: props.onScrolledRight,
    images: props.images
  };
  return ___EmotionJSX("div", null, mobile && hasAgents && ___EmotionJSX(StickyMobile, {
    limitRef: enquiryFormStart
  }, ___EmotionJSX(MobileEnquiryCTAGraphQL, {
    property: property,
    onEmailClick: () => handleEmailClick(property.agencies[0]),
    applyOnlineLink: props.applyOnlineLink
  })), isChildDev && ___EmotionJSX(DevelopmentHeader, {
    backgroundColour: (_property$development = property.development) === null || _property$development === void 0 ? void 0 : (_property$development2 = _property$development.logo) === null || _property$development2 === void 0 ? void 0 : _property$development2.backgroundColour,
    foregroundColour: (_property$development3 = property.development) === null || _property$development3 === void 0 ? void 0 : (_property$development4 = _property$development3.logo) === null || _property$development4 === void 0 ? void 0 : _property$development4.foregroundColour,
    logo: (_property$development5 = property.development) === null || _property$development5 === void 0 ? void 0 : (_property$development6 = _property$development5.logo) === null || _property$development6 === void 0 ? void 0 : _property$development6.image
  }), mobile && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(HeroImages, null, ___EmotionJSX(ListingPhotoPreview, previewProps), props.carouselOpen && !isEmpty((_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : (_property$listing$med = _property$listing.media) === null || _property$listing$med === void 0 ? void 0 : _property$listing$med.items) && ___EmotionJSX(EventBoundary, {
    name: "listing"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, {
    fullscreenOnOpen: mobile,
    items: props.items,
    initialIndex: props.initialIndex,
    onSlideChange: props.onSlideChange,
    onSlideClick: props.onSlideClick,
    onSlideLeft: props.onSlideLeft,
    onSlideRight: props.onSlideRight,
    onClose: props.onClose
  })), props.historyGalleryOpen && ___EmotionJSX(EventBoundary, {
    name: "history"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, _extends({}, props.historyGalleryProps, {
    fullscreenOnOpen: mobile,
    onSlideChange: props.onPropertyHistoryGalleryChange,
    onSlideLeft: props.onPropertyHistoryGalleryLeft,
    onSlideRight: props.onPropertyHistoryGalleryRight,
    onSlideClick: props.onPropertyHistoryGalleryClick
  }))), (mobile || tablet) && ___EmotionJSX("div", {
    css: sharedStyles.watchlistButton
  }, ___EmotionJSX(AllhomesWatchlistButton, {
    listingId: parseInt(property.listing.id, 10),
    onAddToWatchlist: props.onAddToWatchlist,
    popupAlignment: "right",
    inactiveColour: variables.colour.white,
    activeColour: variables.colour.brandYellow
  }))), mobile && !isEmpty(property === null || property === void 0 ? void 0 : (_property$listing2 = property.listing) === null || _property$listing2 === void 0 ? void 0 : _property$listing2.inspections) && ___EmotionJSX("div", null, ___EmotionJSX(NextEventGraphQL, {
    property: property
  })), ___EmotionJSX(Inner, null, tablet && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(InnerLeft, null, desktop && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(AllhomesListingSummaryGraphQL, {
    property: property,
    onAddToWatchlist: props.onAddToWatchlist,
    onResizeFinished: () => window.dispatchEvent(new Event('resize')),
    onLogoClicked: handleEmailClick,
    scrollToAuction: scrollToAuction,
    clientRenderedDescription: props.clientRenderedDescription
  }, (toggledFeatures === null || toggledFeatures === void 0 ? void 0 : toggledFeatures.PEPPERMONEY_CTA) && props.pepperMoneyLink && isForSale && ___EmotionJSX(PepperMoney, {
    href: props.pepperMoneyLink
  }), ___EmotionJSX(NbnCardGraphQL, {
    property: property
  })), ___EmotionJSX(FeaturedArticle, {
    article: property.listing.featuredArticle
  }), !isEmpty(property.listing.documents) && ___EmotionJSX(Section, null, ___EmotionJSX(DocumentsGraphQL, {
    property: property
  })), ___EmotionJSX(Section, null, ___EmotionJSX(InspectionsAuctionsGraphQL, {
    property: property,
    onRemoveFromPlanner: props.onRemoveFromPlannerClick,
    onSignUpClick: props.onSignUpClick,
    onLogInClick: props.onLogInClick,
    onBookHomepassInspectionClick: onBookHomepassInspectionClick,
    onContactAgentClick: handleEmailClick,
    onOnlineAuctionInfoClick: props.onOnlineAuctionInfoClick,
    onRegisterForAuctionClick: () => {
      handleEmailClick();
      props.onRegisterAuction();
    },
    onVideoClick: props.onClickVideo,
    onVirtualTourClick: props.onClickVirtualTour
  })), (tablet || desktop) && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), desktop && isChildDev && ___EmotionJSX(Section, null, ___EmotionJSX(NewDevelopmentChildDetailsGraphQL, {
    property: property,
    onChildDevelopmentLinkClick: handleChildDevelopmentLinkClick
  })), ___EmotionJSX("div", {
    ref: sidebarBottomRef
  })), (tablet || desktop) && ___EmotionJSX(InnerRight, {
    "data-testid": "inner-right"
  }, ___EmotionJSX(StickySidebox, {
    sidebarBottom: sidebarBottomRef
  }, ___EmotionJSX(OnMarketSidebox, _extends({}, props, {
    property: property,
    onEmailClick: handleEmailClick
  })))), ___EmotionJSX(Clear, null), tablet && isChildDev && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(NewDevelopmentChildDetailsGraphQL, {
    property: property,
    onChildDevelopmentLinkClick: handleChildDevelopmentLinkClick
  })), !isEmpty(property.address.coordinates) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(Clear, null), ___EmotionJSX(AllhomesListingMapGraphQL, _extends({
    property: property,
    onTabSelect: props.onMapTypeSelect,
    onOverlaySelect: props.onMapOverlaySelect,
    onMapFirstInteraction: props.onMapFirstInteraction
  }, props))), mobile && isChildDev && ___EmotionJSX(Section, null, ___EmotionJSX(NewDevelopmentChildDetailsGraphQL, {
    property: property,
    onChildDevelopmentLinkClick: handleChildDevelopmentLinkClick
  })), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), mobile && showNearbySales && ___EmotionJSX(Section, null, ___EmotionJSX(NearbySales, {
    layout: "vertical",
    listingVisibility: (_props$listingVisibil = props.listingVisibility) === null || _props$listingVisibil === void 0 ? void 0 : _props$listingVisibil.sale,
    nearbySales: property.address.nearbySales,
    signedOutProps: {
      line1: property.address.line1,
      division: property.address.division.name
    }
  })), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "mobile"
  })), !mobile && showNearbySales && ((_property$address = property.address) === null || _property$address === void 0 ? void 0 : _property$address.nearbySales) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(NearbySales, {
    layout: "horizontal",
    listingVisibility: (_props$listingVisibil2 = props.listingVisibility) === null || _props$listingVisibil2 === void 0 ? void 0 : _props$listingVisibil2.sale,
    nearbySales: (_property$address2 = property.address) === null || _property$address2 === void 0 ? void 0 : _property$address2.nearbySales,
    signedOutProps: {
      line1: (_property$address3 = property.address) === null || _property$address3 === void 0 ? void 0 : _property$address3.line1,
      division: (_property$address4 = property.address) === null || _property$address4 === void 0 ? void 0 : (_property$address4$di = _property$address4.division) === null || _property$address4$di === void 0 ? void 0 : _property$address4$di.name
    }
  })), !isEmpty(property.address.nearbyPOIs) && ___EmotionJSX(Section, {
    fullWidth: true,
    borderless: mobile
  }, ___EmotionJSX(AllhomesListingWhatsNearbyGraphQL, {
    property: property,
    columns: desktop ? 3 : 2
  })), ___EmotionJSX(Bottom, null, !isChildDev && ___EmotionJSX(Fragment, null, ___EmotionJSX(Element, {
    name: "property-history"
  }), ___EmotionJSX("div", {
    css: styles.propertyHistory,
    "data-testid": "section"
  }, ___EmotionJSX(EventBoundary, {
    name: "history"
  }, ___EmotionJSX(PropertyHistoryGraphQL, {
    property: property,
    onPhotoClick: props.openHistoryGallery,
    onSwipeLeft: props.onPropertyHistorySwipeLeft,
    onSwipeRight: props.onPropertyHistorySwipeRight,
    onTapLeftChevron: props.onPropertyHistoryTapLeft,
    onTapRightChevron: props.onPropertyHistoryTapRight,
    onExpand: props.onPropertyHistoryExpand,
    onCollapse: props.onPropertyHistoryCollapse,
    isOnMarket: true
  })))), !isEmpty(property.listing.soi) && ___EmotionJSX(AllhomesListingSoiGraphQL, {
    property: property,
    onContactAgent: () => handleEmailClick(property.agencies[0])
  }), (tablet || desktop) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "tabbed"
  })), ___EmotionJSX("div", {
    ref: enquiryFormStart
  }), ___EmotionJSX(ListingEnquiryFormGraphQL, _extends({
    property: property,
    sponsorship: props.sponsorship
  }, props.enquiryFormProps)), !isEmpty((_property$agents$2 = property.agents[0]) === null || _property$agents$2 === void 0 ? void 0 : _property$agents$2.listings.listings) && ___EmotionJSX("div", {
    css: sharedStyles.moreListingsContainer
  }, ___EmotionJSX(AllhomesListingMoreListingsGraphQL, {
    property: property
  })), hasPrivateLister && props.flagAsInappropriateLink && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(FlagAsInappropriateLink, {
    href: props.flagAsInappropriateLink
  })), (mobile || tablet) && ___EmotionJSX(MobileAdSpot, null))), ___EmotionJSX(ListingViewsGraphQL, {
    property: property
  }), homepassModalOpen && ___EmotionJSX(Modal, {
    closeCallback: closeHomepassModal,
    idealWidth: desktop || tablet ? 500 : 440,
    minimal: false
  }, ___EmotionJSX(HomepassBooking, _extends({}, homepassProps, {
    onCloseModalCallback: closeHomepassModal,
    onSubmit: submitHomepassBooking,
    isV2APIs: true
  }))));
};
BaseOnMarketSalesListingDetails.propTypes = _objectSpread(_objectSpread({}, ListingDetailsCommonProps), {}, {
  onGoToOnlineAuction: PropTypes.func,
  onRegisterAuction: PropTypes.func,
  onOnlineAuctionInformationClick: PropTypes.func,
  onInspectFromHomeClick: PropTypes.func,
  onPromotionViewed: PropTypes.func,
  onPromotionButtonClicked: PropTypes.func,
  pepperMoneyLink: PropTypes.string
});
BaseOnMarketSalesListingDetails.defaultProps = _objectSpread(_objectSpread({}, ListingDetailsDefaultValues), {}, {
  onGoToOnlineAuction: () => {},
  onRegisterAuction: () => {},
  onInspectFromHomeClick: () => {},
  pepperMoneyLink: null
});
export default onMarketPropertyWrapper(withEventBoundary('sales')(BaseOnMarketSalesListingDetails));
export { BaseOnMarketSalesListingDetails };